import { gql } from '@apollo/client';
import SPECIFICATION from '../fragments/SPECIFICATION';
const GET_ORDER = gql `
  ${SPECIFICATION}
  query GetOrder($id: ID!) {
    node(id: $id) {
      ... on OrderNode {
        id
        orderId
        orderDeliveryDate
        sumOfModelQuantities
        allModelsReady
        allComponentVariantsReady
        status
        createdDate
        modifiedDate
        season {
          id
          name
          workingSeason
        }
        correctedOrder {
          id
          orderId
          status
        }
        models {
          edges {
            node {
              id
              modelReady
              modelSpecificationNode {
                ...SpecificationFragment
              }
            }
          }
        }
      }
    }
  }
`;
export default GET_ORDER;
